import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPAvailableTermsDatasource } from '../../global/datasources/ap_available_terms_datasource';

interface IAPAvailableTerm {
  id: number;
  nk: string;
  name: string;
  rank: number;
}
export class APAvailableTermsQuery implements IQuery {
  private __result: {
    availableTerms: IAPAvailableTerm[];
  };
  constructor(QueryMediator: IQueryMediator, private ngAPAvailableTermsDatasource: IAPAvailableTermsDatasource) {
    QueryMediator.registerQuery(this, ngAPAvailableTermsDatasource);
  }
  run(): this {
    const availableTerms: IAPAvailableTerm[] = _4.orderBy(this.ngAPAvailableTermsDatasource.values(), ['rank', 'name']);
    this.__result = {
      availableTerms
    };
    return this;
  }
  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPAvailableTermsQuery', APAvailableTermsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_available_terms_query.ts